import React from 'react';
import { UserInitials } from '../userInitials';

/**
 * @deprecated
 * Legacy wrapper for UserInitials. Prefer to use UserInitials or its child components directly
 */
const UserMenu = ({ children, buttonProps, menuProps, ...restProps }) => {
  return (
    <UserInitials
      buttonProps={buttonProps}
      menuProps={menuProps}
      {...restProps}
    >
      {children}
    </UserInitials>
  );
};

export default UserMenu;
